import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class WorkReportDocumentsApi extends ApiModule {
	constructor() {
		super(ModulesMap.WORK_REPORT_DOCUMENTS, {
			entity: 'work_report_documents',
		})
	}
}
